/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Confirm_BulkInputs */



/**
* | output |
* | --- |
* | "Apply this change to {count} events in {group}?" |
*
* @param {Assistant_Confirm_BulkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_confirm_bulk = /** @type {((inputs: Assistant_Confirm_BulkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Confirm_BulkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Appliquer cette modification aux événements ${i?.count} dans ${i?.group} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Soll diese Änderung auf ${i?.count}-Ereignisse in ${i?.group} angewendet werden?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Applicare questa modifica agli eventi ${i?.count} in ${i?.group}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Применить это изменение к событиям ${i?.count} в ${i?.group}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Aplicar este cambio a los eventos ${i?.count} en ${i?.group}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将此更改应用于 ${i?.group} 中的 ${i?.count} 事件？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`この変更を${i?.group}の${i?.count}イベントに適用しますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या यह बदलाव ${i?.group} में मौजूद ${i?.count} इवेंट्स पर लागू होगा?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Aplicar esta alteração aos eventos ${i?.count} em ${i?.group}?`)
	return /** @type {LocalizedString} */ (`Apply this change to ${i?.count} events in ${i?.group}?`)
});